import { Types } from '@marriott/mi-ui-library';

interface VerticalImageProps {
  fileReferenceImageVertical?: string;
  verticalImageAltText?: string;
}
interface AssetImageProps {
  fileReferenceImage?: string;
  imgAltText?: string;
}
interface MerchandisingHeroBannerIconProps {
  fontIcon: string;
  iconClass?: string;
  fontIconAltText: string;
}
type FontIconAndImageProps = AssetImageProps & MerchandisingHeroBannerIconProps & VerticalImageProps;

export interface MerchandisingHeroBannerAssetProps extends FontIconAndImageProps {
  assetsVariation?: Types.AssetVariation;
  heroSize?: Types.ImageAspectRatio;
  cobrandmathhero?: boolean;
  isCopyBlockWidthWide?: boolean;
  logoImage?: string;
  isLogoFlagEnabled: boolean;
  isMerchHero3X1?: boolean;
  isVariationsAvailable?: boolean;
}

interface FontIconSize {
  mobileSize: number;
  deskTopSize: number;
}

export const FONT_ICON_SIZES: Record<string, FontIconSize> = {
  RZ: { mobileSize: 57.28, deskTopSize: 71.68 },
  EB: { mobileSize: 22.08, deskTopSize: 27.52 },
  JW: { mobileSize: 47.36, deskTopSize: 59.2 },
  AK: { mobileSize: 49.92, deskTopSize: 62.72 },
  BR: { mobileSize: 63.04, deskTopSize: 78.56 },
  GE: { mobileSize: 57.6, deskTopSize: 72.8 },
  CY: { mobileSize: 18.56, deskTopSize: 23.2 },
  RI: { mobileSize: 21.6, deskTopSize: 27.04 },
  SH: { mobileSize: 44.8, deskTopSize: 56.32 },
  FI: { mobileSize: 33.76, deskTopSize: 42.24 },
  TS: { mobileSize: 40.32, deskTopSize: 50.24 },
  PR: { mobileSize: 52.48, deskTopSize: 65.44 },
  OX: { mobileSize: 40.64, deskTopSize: 50.88 },
  LC: { mobileSize: 65.6, deskTopSize: 81.92 },
  WI: { mobileSize: 26.88, deskTopSize: 33.44 },
  SI: { mobileSize: 56.32, deskTopSize: 70.4 },
  MD: { mobileSize: 17.6, deskTopSize: 22.08 },
  TX: { mobileSize: 24.8, deskTopSize: 31.04 },
  DS: { mobileSize: 12.4, deskTopSize: 15.5 },
  BG: { mobileSize: 27.76, deskTopSize: 34.72 },
  AL: { mobileSize: 56, deskTopSize: 70.08 },
  HV: { mobileSize: 52, deskTopSize: 64.96 },
  DEFAULT: { mobileSize: 56, deskTopSize: 64 },
};
